initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  initslide();
});  


function initslide() {
  $('.M-trustpilot-slider-home').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '200px',
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          centerMode: true,
          centerPadding: '80px',
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          centerMode: true,
          arrows: false,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
document.addEventListener("DOMContentLoaded", function() {
  var coll = document.getElementsByClassName("u-accordion-item-title");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var desc = content.querySelector(".u-accordion-item-desc");
      if (content.style.maxHeight) {
        content.style.maxHeight = null; 
      } else {
        content.style.maxHeight = content.scrollHeight + "px"; 
      }
    });
  }
});